import Utils from './Utils';
import Fuse from 'fuse.js';
import TrackData from '@/vo/TrackData';

export default class AnswerTester {
	
	private static _instance:AnswerTester;

	private verbose:boolean = false;
	
	constructor() {
		this.initialize();
	}
	
	
	
	/********************
	 * GETTER / SETTERS *
	 ********************/
	
	/**
	 * Gets the singleton's reference
	 */
	public static get instance():AnswerTester {
		if(!this._instance) this._instance = new AnswerTester();
		return this._instance;
	}
	
	
	
	/******************
	 * PUBLIC METHODS *
	 ******************/
	public run():void {
		this.checkTest("dont stop", "don't stop moving", true);
		this.checkTest("worlds", "worlds appart", true);
		this.checkTest("worlds ap", "worlds appart", true);
		this.checkTest("showbiz", "Showbiz (the battle)", true);
		this.checkTest("papa", "Papa pingouin", false);
		this.checkTest("pingouin", "Papa pingouin", true);
		this.checkTest("franky vinc", "Francky Vincent", true);
		this.checkTest("franky vincen", "Francky Vincent", true);
		this.checkTest("freedom", "Freedom! '90", true);
		this.checkTest("wassup", "What's Up?", false);
		this.checkTest("lambé", "Lambé An Dro", true);
		this.checkTest("redhot hcilli pappers", "Red Hot Chili Peppers", true);
		this.checkTest("walk on the", "Walk On the Wild Side", true);
		this.checkTest("shame on you", "Shame on U", true);
		this.checkTest("stach stach", "Stach Stach — Karaoké Avec Chant Témoin — Rendu Célèbre Par Bratisla Boys", true);
		this.checkTest("que calor", "Que Calor (feat. J Balvin & El Alfa)", true);
		this.checkTest("test of a title", "test of a title longer than (the parenthesis)", true);
		this.checkTest("test with a (complete answer !)", "test with a (complete answer !)", true);
		this.checkTest("death bed", "death bed (coffee for your head) (feat. beabadoobee)", true);
		this.checkTest("bed", "death bed (coffee for your head) (feat. beabadoobee)", false);
		this.checkTest("coffee for your", "death bed (coffee for your head) (feat. beabadoobee)", true);
		this.checkTest("céliendion", "Céline Dion", true);
		this.checkTest("Sabaton", "jackson", false);
		this.checkTest("....", "Eminem", false);
		this.checkTest("kick ass", "Stand Up - Kick Ass film score version", true);
		this.checkTest("A nous", "À nous - extrait de \"Robin des Bois\"", true);
		this.checkTest("inception", "Inception (Music From The Motion Picture)", true);
		this.checkTest("les visiteurs", "Les Visiteurs: Ils ne sont pas nés d'hier ! (Bande originale du film)", true);
		this.checkTest("... ", "Bruno Mars", false);
		this.checkTest("wavin'flag", "Wavin' Flag - Coca-Cola Celebration Mix", true);
		this.checkTest("Murder On Dancefloor", "Murder On The Dancefloor", true);
		this.checkTest("ma sorciere bien", "Ma Sorcière Bien Aimée", true);//In this expected answer "é" and "è" are not actual simple char but a E followed by a modifier.
		this.checkTest("twin", "Twin Peaks", true);
		this.checkTest("alerte a malibu", "Alerte À Malibu", true);

		// this.testFuse([{id:"0", name: "death bed (coffee for your head) (feat. beabadoobee)", artist:"kf", audioPath:""}], "coffee for your head")
	}

	/**
	 * Search within a collection of track via Fuse.js search engine
	 * This is just a test for a new way of matching results
	 * It's not used in game as it's not so good in its current state
	 * but i keep it just in case.
	 */
	public testFuse(tracksList:TrackData[], userAnswer:string):TrackData {
		let minAnswer = 999999;
		for (let i = 0; i < tracksList.length; i++) {
			const t = tracksList[i];
			if(t.artist.length < minAnswer) minAnswer = t.artist.length;
			if(t.name.length < minAnswer) minAnswer = t.name.length;
		}
		minAnswer *= .25;
		console.log("MIN SEARCH", minAnswer)

		let opts = {
			includeScore: true,
			includeMatches: true,
			minMatchCharLength: minAnswer,
			// Search in `author` and in `tags` array
			keys: ['artist', 'name']
		}
		let search = new Fuse(tracksList, opts);
		let res = search.search(userAnswer);
		console.log(res);
		for (let i = 0; i < res.length; i++) {
			console.log(res[i].item.artist, res[i].item.name, " ==> ", res[i]);
			let minSize = res[i].matches[0].value.replace(/(.*)(\[|\().*?(\)|\])$/gi, "$1").length * .5;
			console.log(userAnswer.length, minSize);
			if(res[i].score < .35 && userAnswer.length >= minSize) {
				return res[i].item;
			}
		}
		return null;
	}

	/**
	 * Test a user answer compared to an expected answer
	 */
	public test(userAnswer:string, expectedAnswer:string, reducedTolerence:boolean = false):boolean {
		expectedAnswer = expectedAnswer.trim();
		//remove some arbitrary data like "- radio edit" from names.
		//not a big fan of these but couldn't find any alternative
		expectedAnswer = expectedAnswer.replace(/ ?- ?(original)?.?radio.edit/gi, "").trim();
		expectedAnswer = expectedAnswer.replace(/ ?- ?version radio/gi, "").trim();
		expectedAnswer = expectedAnswer.replace(/ ?- ?bonus track/gi, "").trim();

		//If string ends with something between parenthesis/brackets, test the answer without the parenthesis
		//and, if it fail, proceed to normal testing
		let tmpAnswer = expectedAnswer.replace(/(.*)(\[|\().*?(\)|\])$/gi, "$1").trim();
		if(tmpAnswer.length != expectedAnswer.length ) {
			//recursive test until there are no more ending parenthesis
			if(this.test(userAnswer, tmpAnswer, reducedTolerence)) return true;
		}

		//Remove punctuation to make it easier
		let cleanAnswer = this.cleanup(expectedAnswer);
		let cleanUserAnswer = this.cleanup(userAnswer);
		let chunks = expectedAnswer.split(" ").map(s => this.cleanup(s));
		let tolerence = reducedTolerence? .18 : .28;
		
		//Check for answer with elastic error tolerence
		let costs = {insert:null, remove:.5, substitute:.5, transpose:0};
		// console.log(Utils.levenshtein(cleanUserAnswer, cleanAnswer), Utils.levenshteinDamerau(cleanUserAnswer, cleanAnswer, costs), cleanAnswer)
		let res1 = Utils.levenshteinDamerau(cleanUserAnswer, cleanAnswer, costs) < cleanAnswer.length * tolerence;
		if(this.verbose) {
			console.log("%cLevenstein :", "font-size:16px;color:blue;font-weight:bold"+(res1? ";color:green" : ";color:red"), cleanUserAnswer + " VS " + cleanAnswer, Utils.levenshteinDamerau(cleanUserAnswer, cleanAnswer, costs), "/", (cleanAnswer.length * tolerence).toFixed(1));
		}

		//check for exact occurence in answer to be able to write a shortened version of the answer.
		let res2 = (cleanUserAnswer.length >= cleanAnswer.length * .5) && cleanAnswer.indexOf(cleanUserAnswer) > -1 && cleanUserAnswer.length > 0;
		if(this.verbose) {
			console.log("%cShort answer :", "font-size:16px;color:blue;font-weight:bold"+(res2? ";color:green" : ";color:red"), res2);
		}

		//check for one specific word longer than 5 chars (might be too permissive...)
		let res3 = (userAnswer.length >= 5 || cleanUserAnswer.length >= cleanAnswer.length * .5) && chunks.indexOf(cleanUserAnswer) > -1 && cleanUserAnswer.length > 0;
		if(this.verbose) {
			console.log("%cExact word :", "font-size:16px;color:blue;font-weight:bold"+(res3? ";color:green" : ";color:red"), res3);
		}

		//If answer is longer than 8 chars, check its exact match (this is a workaround for stupidly long titles with useless informations on it)
		let res4 = (userAnswer.length >= 9) && cleanAnswer.indexOf(cleanUserAnswer) > -1 && cleanUserAnswer.length > 0;
		if(this.verbose) {
			console.log("%cExact word long :", "font-size:16px;color:blue;font-weight:bold"+(res4? ";color:green" : ";color:red"), res4, userAnswer, cleanAnswer.indexOf(cleanUserAnswer));
		}

		//check for a group of words if there are more than 5 chars
		let res5 = (cleanUserAnswer.split(" ").length > 1 && cleanUserAnswer.length > 5 && cleanAnswer.indexOf(cleanUserAnswer) > -1);
		// console.log(cleanUserAnswer.split(" "), cleanAnswer.indexOf(cleanUserAnswer));
		if(this.verbose) {
			console.log("%cExact word group :", "font-size:16px;color:blue;font-weight:bold"+(res5? ";color:green" : ";color:red"), res5);
		}
		
		if(this.verbose) console.log("");
		
		return res1 || res2 || res3 || res4 || res5;
	}
	
	
	
	/*******************
	 * PRIVATE METHODS *
	 *******************/
	/**
	 * Initializes the class
	 */
	private initialize():void {
		
	}

	private checkTest(answer:string, expected:string, result:boolean):void {
		if(this.test(answer, expected) !== result) {
			console.warn("Test failed : ", answer, " :: ", expected);
		}
	}

	private cleanup(str:string):string {
		
		return Utils.removeDiacritics(str).toLowerCase()
		//This is a modifier found to be used by a spotify track to make "è" instead
		//of just using the actual "è". Some people are weird on this planet... (same for "é")
		.replace(/̀/gi, "")
		.replace(/́/gi, "")
		//Special case to replace apostrophes by nothing only if it's followed by only one char.
		//Ex:"don't" will become "dont" but "wavin'flag" won't be changed and next rule will
		//replace the apostrophe by a space
		.replace(/('|`)([^\s]{0,1}(?!\w))/gi, "$2")
		.replace(/[^A-z0-9 ]/gi, " ")
		.replace(/\s{2,}/gi, " ").trim();
	}
}